import { OptionType } from "@qendo/types";
import type { QendoIconSet } from "~/components/QendoIcon";

export enum MedicalType {
    allergy = "allergies",
    condition = "conditions",
    immunisation = "immunisations",
    medication = "medications",
    past_symptom = "symptoms",
    supplement = "supplements",
    surgery = "surgeries",
    trigger = "triggers",
}

export interface BaseMedical<T extends MedicalType> {
    readonly type: T;
    description: string | null;
    option_id: string | null;
    photograph_ids: string[] | null;
}

export interface Medical<T extends MedicalType> extends BaseMedical<T> {
    id?: string;
}

export const MedicalIconMap: Record<MedicalType, QendoIconSet> = {
    [MedicalType.allergy]: "denied",
    [MedicalType.condition]: "heart-plus",
    [MedicalType.immunisation]: "vaccine",
    [MedicalType.medication]: "medication",
    [MedicalType.past_symptom]: "search",
    [MedicalType.supplement]: "medication",
    [MedicalType.surgery]: "ambulance",
    [MedicalType.trigger]: "zap",
};

export const MedicalTypeNameMap: Record<MedicalType, string> = {
    [MedicalType.allergy]: "allergy",
    [MedicalType.condition]: "condition",
    [MedicalType.immunisation]: "immunisation",
    [MedicalType.medication]: "medication",
    [MedicalType.past_symptom]: "past symptom",
    [MedicalType.supplement]: "supplement",
    [MedicalType.surgery]: "surgery",
    [MedicalType.trigger]: "trigger",
};

export const MedicalOptionTypeMap: Record<MedicalType, OptionType> = {
    [MedicalType.allergy]: OptionType.allergies,
    [MedicalType.condition]: OptionType.conditions,
    [MedicalType.immunisation]: OptionType.immunisations,
    [MedicalType.medication]: OptionType.medications,
    [MedicalType.past_symptom]: OptionType.past_symptoms,
    [MedicalType.supplement]: OptionType.supplements,
    [MedicalType.surgery]: OptionType.surgeries,
    [MedicalType.trigger]: OptionType.triggers,
};
